import { ComboItem, Response } from "../../../../model";
import { PaisEditIn, PaisEditOut, PersonaEditIn, PersonaEditOut, PersonaListOut, RegionEditIn, RegionEditOut, UsuarioComboItem, UsuarioEditIn, UsuarioEditOut, UsuarioListOut } from "../../../../model/seguridad";
import ServiceBase from "../../../servicebase";
import { ControllerEntityService } from "./ControllerEntityService";

export class SeguridadService extends ServiceBase {
  private controller: string = 'seguridad';

  Pais = () => new ControllerEntityService<PaisEditOut, PaisEditIn, PaisEditOut, ComboItem, { }, { }>(this.urlAPI, this.controller, "Pais");

  Region = () => new ControllerEntityService<RegionEditOut, RegionEditIn, RegionEditOut, ComboItem, { }, { }>(this.urlAPI, this.controller, "Region");

  Usuario = () => new UsuarioService(this.urlAPI, this.controller);

  Persona = () => new ControllerEntityService<PersonaEditOut, PersonaEditIn, PersonaListOut, ComboItem, { }, { }>(this.urlAPI, this.controller, "Persona");
}



export class UsuarioService extends ControllerEntityService<UsuarioEditOut, UsuarioEditIn, UsuarioListOut, UsuarioComboItem, { codigo?: string, nombre?: string }, { hasRol?: string }> {
  constructor(urlApi: string, controller: string) {
    super(urlApi, controller, "Usuario");
  }

  recoverypass = (data: { user?: string, idioma: string, urlCallback: string }) => 
    this.GetFetch<Response<any>>(`${this._controller}/${this._entity}/recoverypass`, data);
}
